import React from "react";

/** Registered brand mark — use wherever the full studio name appears in UI text */
export default function BrandName({ className = "" }) {
  return (
    <span className={className}>
      TwinFrame Studios
      <sup className="text-[0.85em] leading-none" style={{ marginLeft: "0.05em", top: "-0.2em" }}>
        ®
      </sup>
    </span>
  );
}

/** Plain string for titles / meta / attributes */
export const BRAND_NAME = "TwinFrame Studios®";
